import axios from "axios";
import i18n from "../../i18n";
import { dayStart, dayEnd } from "../../utils/dateRange";

const actions = {
  approveMedkitlog(context, { id }) {
    return axios
      .post("medkitlog/" + id + "/approve")
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.proof.proofedMessage"),
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  rejectMedkitlog(context, { id, reason }) {
    return axios
      .post("medkitlog/" + id + "/reject", { reason })
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.proof.rejectedMessage"),
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  getMedkitlogVersions(context, id) {
    return axios
      .get("medkitlog/" + id + "/versions")
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
        return { versions: [], currentVersion: 0, canProof: false };
      });
  },

  bulkDeleteMedkitlogs(context, ids) {
    return axios
      .post("medkitlog/bulk-delete", { ids })
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("medkitlogs.bulk.deletedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getMedkitlogYearCounts(context) {
    return axios
      .get("medkitlog/yearCounts")
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },

  getMedkitlogMonthCounts(context, year) {
    return axios
      .get("medkitlog/monthCounts", { params: { year } })
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },

  createMedkitlog(context, value) {
    return axios
      .post("medkitlog", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("medkitlogs.createdMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  createMedkitlogByQrCode(context, value) {
    return axios
      .post(`medkitlog/qrCode/${value.qrCodeKey}`, value.medkitlog)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("medkitlogs.createdMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteMedkitlog(context, val) {
    return axios
      .delete("medkitlog/" + val.id)
      .then(function (res) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("medkitlogs.deletedMessage"),
        );
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateMedkitlog(context, value) {
    return axios
      .put("medkitlog/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("medkitlogs.updatedMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getAllMedkitlogs(context) {
    return axios
      .get("medkitlog/")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleMedkitlog(context, id) {
    return axios
      .get("medkitlog/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getMedkitlogStats(context) {
    return axios
      .get("medkitlog/stats")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  createMedkitlogPdf(context, value) {
    return axios
      .get(
        "medkitlog/pdf?start=" +
          dayStart(value.start).toISOString() +
          "&end=" +
          dayEnd(value.end).toISOString(),
      )
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  newMedkitlogQrCode(context) {
    return axios
      .post("medkitlog/qrCode")
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("medkitlogs.qrCreated"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  deleteMedkitlogQrCode(context) {
    return axios
      .delete("medkitlog/qrCode")
      .then(function (res) {
        context.commit("CREATE_SNACKBAR", i18n.t("medkitlogs.qrDeleted"));
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
